import {DataFrame, DataFrameRow} from 'data-frames/DataFrameTypes';
import {DataFrameTableMode} from 'data-frames/table/DataFrameTableConstants';
import {rowIdAccessor} from 'data-frames/util/createAccessors';
import getUserColumns from 'data-frames/util/getUserColumns';
import * as ExportUtil from 'util/ExportUtil';

import cellValueToUserFacingString from './cellValueToUserFacingString';
import filterRows from './filterRows';

function exportRow(row: DataFrameRow, dataFrame: DataFrame, tableMode: DataFrameTableMode): Array<string> {
  return getUserColumns(dataFrame).map((column) =>
    cellValueToUserFacingString(row[column.systemName], column, dataFrame.hydratedProperties, tableMode)
  );
}

export default function makeDataFrameExportString(
  dataFrame: DataFrame,
  selectedRowIds: Set<string>,
  tableMode: DataFrameTableMode,
  delimiter: string = ','
): string {
  const filteredRows =
    selectedRowIds.size === 0
      ? dataFrame.rows
      : filterRows(dataFrame, (dataRow) => selectedRowIds.has(rowIdAccessor(dataRow))).rows;

  const exportedRows = [
    getUserColumns(dataFrame).map((column) => column.displayName),
    ...filteredRows.map((row) => exportRow(row, dataFrame, tableMode)),
  ];
  return ExportUtil.formatRows(exportedRows, delimiter);
}
